import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

import { MessageService } from 'primeng/components/common/messageservice';
import { WebPage } from '../../shared/web-page';
import { FaseService } from '../../fase/fase.service';

import { Perfis } from '../../../models/perfis';
import { AuthService } from '../../admin/auth.service';

import { ExcelService } from '../../../services/excel.service';
import { DomSanitizer } from '@angular/platform-browser';
import { DropdownModule } from 'primeng/primeng';
import { saveAs } from 'file-saver';

@Component({
  templateUrl: './relatorio-integracao-detran.component.html'
})
export class RelatorioIntegracaoDetranComponent
  extends WebPage
  implements OnInit
{
  fases;
  perfis: any = {};
  unidades = [];
  usuario: any = {};
  faseUnidade;
  candidatos = [];
  candidatosTxt = [];

  form: FormGroup;
  fileUrl;
  constructor(
    private fb: FormBuilder,
    private faseService: FaseService,
    messageService: MessageService,
    private authService: AuthService,
    private excelService: ExcelService,
    private sanitizer: DomSanitizer
  ) {
    super(messageService);
    
    this.perfis = Perfis;
    this.form = this.fb.group({
      idFase: [null, Validators.required]
    });
  }

  ngOnInit() {
    this.isLoading = true;
    this.usuario = this.authService.informacoesUsuario();
    this.faseService
      .getAll()
      .finally(() => (this.isLoading = false))
      .subscribe(
        (fases) => (this.fases = fases),
        (error) => this.gerenciaErro(error)
      );
    this.criarForm();
  }

  private criarForm() {
    this.form = this.fb.group({
      idFase: ['', [Validators.required]],
      idUnidade: ['']
    });
  }

  obterUnidades(idFase) {
    if (
      this.usuario.Perfil === this.perfis.AdministrativoUnidadeOperacional ||
      this.usuario.Perfil === this.perfis.GestorUnidadeOperacional
    ) {
      return;
    }
    if (!idFase) {
      this.unidades = [];
      return;
    }

    this.faseService.getFull(idFase).subscribe((x) => {
      this.unidades = x.faseUnidades;
    });
  }

  submit() {
    if (this.form.invalid) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'Formulário preenchido incorretamente.'
      });
      return false;
    }

    this.isLoading = true;

    if(this.form.controls.idUnidade.value === '')
      this.form.value.idUnidade = this.usuario.IdUnidade;
    else
      this.idUnidade.setValue(this.form.value.idUnidade);

    this.faseService
      .getRelatorioIntegracaoDetran(this.form.value)
      .finally(() => (this.isLoading = false))
      .subscribe(
        (candidatos) => {
          this.candidatos = candidatos;

          if (candidatos.every((ui) => ui.numeroInscritos === 0)) {
            this.messageService.add({
              severity: 'warn',
              summary: 'Atenção',
              detail: 'Nenhum registro encontrado!'
            });
          }
        },
        (error) => this.gerenciaErro(error)
      );
  }

  baixarExcel() {
    this.criarExcelRelatorioDetalhado(this.candidatos);
  }

  criarExcelRelatorioDetalhado(candidatos: any): void {
    const relatorio = [];
    const fase = this.fases.filter(
      (fase) => fase.idFase == this.idFase.value
    );
    console.log(this.unidades);
    const unidade = this.unidades.filter(
      (unidade) => unidade.idUnidade == this.idUnidade.value ? '' : this.usuario.IdUnidade
    );
    candidatos.forEach((x) => {
      relatorio.push({
        TIPO_OPERACAO: x.tipoOperacao,
        CPF: x.cpf,
        NUM_REGISTRO: x.numeroRegistro,
        EMAIL: x.email,
        NOME_CONDUTOR: x.nomeCondutor,
        DATA_DE_NASCIMENTO: x.dataNascimento,
        MUNICIPIO: x.municipio,
        CATEGORIA_PRETENDIDA: x.categoriaPretendida,
        TELEFONE_CELULAR: x.telefoneCelular,
        DATA_DE_CONVOCACAO: x.dataConvocacao,
      });
    });

    var unidadeFull;

    if(this.usuario.Perfil === this.perfis.AdministradorSistema || this.usuario.Perfil === this.perfis.GestorDex)
      unidadeFull = unidade[0].unidade.tipologia + ` - ` + unidade[0].unidade.nomeUnidade + ` - `;
    else
      unidadeFull = this.usuario.NomeUnidade + ` - `;

    this.excelService.exportAsExcelFile(
      relatorio,
      fase[0].nroFase + ` - ` + fase[0].nomeFase + ` - ` + unidadeFull + `Integração DETRAN`
    );
    
  }

  baixarTxt() {
    this.isLoading = true;

    if(this.form.controls.idUnidade.value === '')
      this.form.value.idUnidade = this.usuario.IdUnidade;

    const fase = this.fases.filter(
      (fase) => fase.idFase === this.idFase.value
    );
    const unidade = this.unidades.filter(
      (unidade) => unidade.idUnidade == this.idUnidade.value
    );

    this.faseService
      .getRelatorioIntegracaoDetranTxt(this.form.value.idFase, this.form.value.idUnidade)
      .finally(() => (this.isLoading = false))
      .subscribe(data => {
        var unidadeFull = this.usuario.Perfil === this.perfis.AdministradorSistema || this.usuario.Perfil === this.perfis.GestorDex ?
                          unidade[0].unidade.tipologia + ` - ` + unidade[0].unidade.nomeUnidade + ` - ` :
                          this.usuario.NomeUnidade + ` - `;
  
        const fileName = fase[0].nroFase + ` - ` + fase[0].nomeFase + ` - ` + unidadeFull + `Integração DETRAN` + `.txt`;
        
        let blob = new Blob([data], { type: 'text/plain' });
        saveAs(blob, fileName);
      });

  }

  get idFase() {
    return this.form.controls.idFase;
  }
  get idUnidade() {
    return this.form.controls.idUnidade;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/candidato/relatorio-integracao-detran/relatorio-integracao-detran.component.ts